import * as React from 'react'

import './Icon.scss'

interface IconProps {
  id?: string
  icon: JSX.Element
  viewBox?: string
  onClick?: (e: React.MouseEvent<any>) => void
  className?: string
  iconProps?: object
}

const Icon: React.FC<IconProps> = props => {
  return (
    <span
      className={`srprs-icon${props.className ? ` ${props.className}` : ''}`}
      id={props.id ? props.id : ''}
      onClick={props.onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={props.viewBox ? props.viewBox : '0 0 512 512'}
        {...props?.iconProps}
      >
        {props.icon}
      </svg>
    </span>
  )
}

export default Icon
